// Components
import ContactInfo from "components/Filters/ContactInfo";
import NewsletterBox from "components/Filters/NewsletterBox";
import Filters from "components/Filters/Filters";

// Redux
import { useAppSelector } from "redux/hooks";
import { isOpenMobileSidebarSelector } from "redux/filters/filtersSlice";
import { isMobileSelector } from "redux/pagination/paginationSlice";

const Sidebar = () => {
	const isOpenMobileSidebar = useAppSelector(isOpenMobileSidebarSelector);
	const isMobile = useAppSelector(isMobileSelector);

	return (
		<>
			<div className={`sidebar ${isOpenMobileSidebar ? "sidebar--mobile-active" : ""}`}>
				{!isMobile && <ContactInfo />}
				<Filters/>
				{!isMobile && <NewsletterBox />}
			</div>
			{isMobile && (
				<div className="sidebar sidebar-mobile">
					<ContactInfo />
					<NewsletterBox />
				</div>
			)}
		</>
	);
};

export default Sidebar;
